const carouselItems = [
  {
    title: '51吃瓜爆料每日大赛特别专题',
    desc: '本期吃瓜大赛汇集了近一周最火爆的赛事内幕，从电竞圈人事变动到体育界转会风波，带你一次性吃够所有大瓜。',
    tag: '热门专题',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20news%20collage%20with%20esports%20arena%20and%20breaking%20news%20visuals%2C%20warm%20red%20and%20dark%20tones%2C%20editorial%20magazine%20style%2C%20dramatic%20composition%20with%20headline%20overlay%2C%20professional%20news%20media%20aesthetic%2C%20bold%20contrast%20lighting&width=600&height=400&seq=carousel-01-51&orientation=landscape',
  },
  {
    title: '本月最劲爆大赛内幕汇总',
    desc: '五大联赛转会窗口最新动态全解析，多位明星选手合同细节遭曝光，涉及金额令人瞠目结舌。',
    tag: '深度爆料',
    image: 'https://readdy.ai/api/search-image?query=Sports%20stadium%20atmosphere%20with%20dramatic%20lighting%2C%20transfer%20news%20theme%2C%20professional%20sports%20photography%20style%2C%20warm%20golden%20and%20dark%20contrast%2C%20editorial%20magazine%20layout%2C%20athletic%20competition%20visuals&width=600&height=400&seq=carousel-02-51&orientation=landscape',
  },
  {
    title: '电竞圈赛季风云变幻实录',
    desc: 'LPL与KPL双线爆料齐发，战队内部训练数据流出，多名选手合约细节被知情人士曝光。',
    tag: '电竞爆料',
    image: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20colorful%20stage%20lights%20and%20gaming%20atmosphere%2C%20competitive%20gaming%20theme%2C%20professional%20esports%20photography%2C%20dramatic%20purple%20and%20warm%20tone%20contrast%2C%20editorial%20style%20composition&width=600&height=400&seq=carousel-03-51&orientation=landscape',
  },
  {
    title: '综艺节目幕后黑幕大起底',
    desc: '当红选秀节目被曝票数造假，多名前工作人员实名举报，节目制作方保持沉默引发更大争议。',
    tag: '综艺揭秘',
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20behind%20scenes%20with%20dramatic%20spotlight%2C%20talent%20show%20atmosphere%2C%20warm%20stage%20lighting%20with%20dark%20shadows%2C%20editorial%20photography%20style%2C%20professional%20production%20set%20visuals&width=600&height=400&seq=carousel-04-51&orientation=landscape',
  },
  {
    title: '游戏行业新作泄露专题',
    desc: '多款备受期待的3A大作核心玩法提前曝光，内部开发文档截图在社交平台疯传，各大厂商紧急公关。',
    tag: '游戏揭秘',
    image: 'https://readdy.ai/api/search-image?query=Gaming%20development%20studio%20with%20screens%20and%20concept%20art%2C%20game%20design%20atmosphere%2C%20warm%20creative%20lighting%2C%20digital%20art%20and%20technology%20theme%2C%20editorial%20style%20composition%2C%20professional%20studio%20visuals&width=600&height=400&seq=carousel-05-51&orientation=landscape',
  },
  {
    title: '51爆料每日大赛周度回顾',
    desc: '本周爆料热度榜TOP10全记录，从体育到电竞再到娱乐圈，回顾本周最引人注目的大赛爆料事件。',
    tag: '周度回顾',
    image: 'https://readdy.ai/api/search-image?query=News%20headlines%20collage%20with%20ranking%20list%20visuals%2C%20top%2010%20chart%20design%2C%20warm%20editorial%20style%2C%20professional%20newsroom%20aesthetic%2C%20dramatic%20typography%20with%20bold%20numbers%2C%20dark%20and%20warm%20contrast&width=600&height=400&seq=carousel-06-51&orientation=landscape',
  },
];

export default function FocusCarousel() {
  return (
    <section id="carousel" className="section-py bg-background-50">
      <div className="section-container">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            焦点爆料
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 text-xs font-semibold bg-primary-500 text-background-50 px-2.5 py-1 rounded">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-2 font-heading leading-snug">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}